import React, { useEffect, useState } from 'react';
import Header from '../molecules/Header';
import LeftBar from '../molecules/LeftBar';
import { useAuth } from '../../context/AuthContext';

const SIDEBAR_COLLAPSED_STORAGE_PREFIX = 'we-soda-sidebar-collapsed';

const getSidebarPreferenceKey = (username) => {
    return username ? `${SIDEBAR_COLLAPSED_STORAGE_PREFIX}:${username.toLowerCase()}` : null;
};

const readSidebarPreference = (username) => {
    const key = getSidebarPreferenceKey(username);

    if (!key) {
        return false;
    }

    try {
        return localStorage.getItem(key) === 'true';
    } catch (error) {
        return false;
    }
};

const writeSidebarPreference = (username, isCollapsed) => {
    const key = getSidebarPreferenceKey(username);

    if (!key) {
        return;
    }

    try {
        localStorage.setItem(key, String(isCollapsed));
    } catch (error) {
        // Keep navigation usable even if browser storage is unavailable.
    }
};

const Layout = ({ children }) => {
    const { user } = useAuth();
    const username = user?.username;
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const nextIsMobile = window.innerWidth <= 768;
            setIsMobile(nextIsMobile);

            if (nextIsMobile) {
                setIsSidebarCollapsed(false);
                setIsMobileSidebarOpen(false);
            } else {
                setIsSidebarCollapsed(readSidebarPreference(username));
                setIsMobileSidebarOpen(false);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [username]);

    const handleToggleSidebar = () => {
        if (isMobile) {
            setIsMobileSidebarOpen((current) => !current);
            return;
        }

        setIsSidebarCollapsed((current) => {
            const nextIsCollapsed = !current;
            writeSidebarPreference(username, nextIsCollapsed);
            return nextIsCollapsed;
        });
    };

    const handleCloseMobileSidebar = () => {
        setIsMobileSidebarOpen(false);
    };

    return (
        <div className={`app-shell ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
            <Header
                isMobile={isMobile}
                onToggleSidebar={handleToggleSidebar}
            />
            <div className="app-body">
                <LeftBar
                    isCollapsed={isSidebarCollapsed}
                    isMobileOpen={isMobileSidebarOpen}
                    onNavigate={handleCloseMobileSidebar}
                />
                {isMobileSidebarOpen && (
                    <button
                        type="button"
                        className="sidebar-backdrop"
                        aria-label="Close navigation"
                        onClick={handleCloseMobileSidebar}
                    />
                )}
                <main className="app-content">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default Layout;
